import { useCallback } from 'react';
import { useGetCatalogQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';

/** Назва типу записів, на який посилається поле (каталог воркспейсу: тип записів будь-якого модуля), мовою інтерфейсу; невідомий — ключ. */
export function useRefName(ws: string): (key: string) => string {
  const label = useLabel();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  return useCallback((key: string) => {
    for (const m of catalog?.modules ?? []) {
      const rt = m.recordTypes.find((r) => r.key === key);
      if (rt) return label(rt.name) || key;
    }
    return key;
  }, [catalog, label]);
}
